import React, {useState} from 'react';
import './App.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles';
import {BrowserRouter as Router} from "react-router-dom";
import MiniDrawer from "./MiniDrawer";
import {SnackbarProvider} from 'notistack';
import {Provider} from 'react-redux';
import store from './store';


const App = () => {


    let paletteType = "light";
    // let isLight = window.matchMedia("(prefers-color-scheme : light)").matches;
    // let isDark = window.matchMedia("(prefers-color-scheme : dark)").matches;

    // if(isDark === true){
    //     paletteType = "dark";
    // }

    const [theme, setTheme] = useState({
        palette: {
            primary: {
                light: '#FFCC80',
                main: '#ffbf00',
                dark: '#E65100',
                contrastText: '#fff',
            },
            secondary: {
                light: '#ff7961',
                main: '#f44336',
                dark: '#ba000d',
                contrastText: '#fff',
            },
            type: paletteType
        },
        typography: {
            useNextVariants: true,
        },
    });
    const toggleDarkTheme = () => {
        let newPalette = {};

        if (theme.palette.type === "light") {
            newPalette = {
                primary: {
                    light: '#FFCC80',
                    main: '#ffbf00',
                    dark: '#E65100',
                    contrastText: '#fff',
                },
                secondary: {
                    light: '#ff7961',
                    main: '#f44336',
                    dark: '#ba000d',
                    contrastText: '#000',
                },
                type: "dark"
            }
        } else {
            newPalette = {
                primary: {
                    light: '#FFCC80',
                    main: '#ffbf00',
                    dark: '#E65100',
                    contrastText: '#fff',
                },
                secondary: {
                    light: '#ff7961',
                    main: '#f44336',
                    dark: '#ba000d',
                    contrastText: '#000',
                },
                type: "light"
            }
        }

        setTheme({
            palette: newPalette
        });
    };

    const muiTheme = createMuiTheme(theme);

    return (


        <Provider store={store}>
            <React.Fragment>
                <CssBaseline/>
                <SnackbarProvider maxSnack={1}>
                    <MuiThemeProvider theme={muiTheme}>
                        <Router>
                            <MiniDrawer toggleDarkTheme={toggleDarkTheme}/>
                        </Router>
                    </MuiThemeProvider>
                </SnackbarProvider>

            </React.Fragment>
        </Provider>
    );

};

export default App;
